import React, { useEffect, useState } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css';

import axios from '../apiClient'
import Alert from '../alert';
import { Button } from 'antd';


export default function Rules() {

    const [openAlert, setOpenAlert] = useState(false);
    const [errorMsg, setErrorMsg] = useState({});
    const [rules, setRules] = useState();

    const modules = {
        toolbar: [
          [{ size: ["small", false, "large", "huge"] }],
          ["bold", "italic", "underline", "strike", "blockquote"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link", "image"],
          [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
            { align: [] }
          ],
          [{ "color": ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466", 'custom-color'] }],
        ]
    };
    
    const formats = [
        "header", "height", "bold", "italic",
        "underline", "strike", "blockquote",
        "list", "color", "bullet", "indent",
        "link", "image", "align", "size",
    ];

    const getRules = async () => {
        const res = await axios.get(`/info/getRules`)
      
        if (res.code != 200) {
          setErrorMsg({ code: res.code, msg: res.message})
          setOpenAlert(true)
          return
        }
        const desc = JSON.parse(res.data.description);
        setRules(desc);
    }

    const updateRules = async () => {
        const params = {
            desc: JSON.stringify(rules)
        }
        const res = await axios.put(`/info/updateRules`,params)
        setErrorMsg({ code: res.code, msg: res.message})
        setOpenAlert(true)      
    }

    const handleCloseAlert = () => setOpenAlert(false)

    useEffect(()=>{
        getRules();
    },[])

    const handleProcedureContentChange = (content) => {
        console.log("content---->", content);
        setRules(content)
    };

    const handleSave = () => {
        updateRules()
    }

    return (
        <div style={{padding: "0 2rem"}}>
            <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
            <Button style={{marginBottom: "1rem",backgroundColor: "rgb(221 221 220)"}} type='dashed' onClick={()=> handleSave()}>
                Save
           </Button>
            <div style={{ display: "grid", justifyContent: "center"}}>
                <ReactQuill
                    value={rules}
                    theme="snow"
                    modules={modules}
                    formats={formats}
                    placeholder="write your content ...."
                    onChange={handleProcedureContentChange}
                    style={{ height: "400px" }}
                    >
                </ReactQuill>
            </div>
        </div>
    )
}
